export const competenceFieldKey = (competenceID) =>
  `competence-${competenceID}`;

export function buildPreschoolLearningAreas(rows) {
  const areas = new Map();

  (Array.isArray(rows) ? rows : []).forEach((entry) => {
    if (entry?.columnID == null || entry?.competenceID == null) return;

    if (!areas.has(entry.columnID)) {
      areas.set(entry.columnID, {
        columnID: entry.columnID,
        columnName: entry.columnName,
        competences: [],
      });
    }

    const area = areas.get(entry.columnID);
    if (
      !area.competences.some((item) => item.competenceID === entry.competenceID)
    ) {
      area.competences.push({
        competenceID: entry.competenceID,
        statement: entry.statement,
        order: entry.competenceOrder,
      });
    }
  });

  return [...areas.values()].map((area) => ({
    ...area,
    competences: area.competences.sort(
      (a, b) =>
        (a.order ?? Number.MAX_SAFE_INTEGER) -
        (b.order ?? Number.MAX_SAFE_INTEGER),
    ),
  }));
}

export function formatPreschoolGrade(entry, gradingRemarks = []) {
  const configuredGrade = (
    Array.isArray(gradingRemarks) ? gradingRemarks : []
  ).find((grade) => String(grade?.id) === String(entry?.gradeID));
  const remark = entry?.gradeRemark ?? configuredGrade?.remark;
  const letter =
    entry?.letterGrade ??
    configuredGrade?.letterGrade ??
    configuredGrade?.letter_grade;

  if (remark && letter) return `${remark} (${letter})`;
  return remark ?? letter ?? "-";
}

export function buildStudentCompetenceScores(entries, gradingRemarks = []) {
  return Object.fromEntries(
    (Array.isArray(entries) ? entries : [])
      .filter((entry) => entry?.competenceID != null)
      .map((entry) => [
        competenceFieldKey(entry.competenceID),
        formatPreschoolGrade(entry, gradingRemarks),
      ]),
  );
}
